module.exports = __webpack_public_path__ + "static/media/c.7f4f8c5a.svg";